module.exports = __webpack_public_path__ + "static/media/SaifeeEvents158.3899a39f.jpg";